import React, {memo, Suspense, useCallback} from 'react'

import FavoriteStar from '../../../../common/FavoriteStar/FavoriteStar'
import {
  useIsAgentPoolFavorite,
  useIsAgentPoolFavoriteLimitReached,
  useToggleAgentPoolFavorite,
} from '../hooks/useAgentPoolFavorite'
import {useIsAgentPoolFavoriteEnabled} from '../hooks/useIsAgentPoolFavoriteEnabled'

interface InnerProps {
  className?: string
  iconWrapperClassName?: string
  id: number
  disabled: boolean
  isStarred: boolean
  onStar: (event: React.MouseEvent<any> | null | undefined) => unknown
}
function AgentPoolFavoriteStarComponent(props: InnerProps) {
  const {disabled, className, iconWrapperClassName, onStar, isStarred} = props

  return (
    <Suspense>
      <FavoriteStar
        title={disabled ? 'You have reached the limit of favorite agent pools' : undefined}
        className={className}
        iconWrapperClassName={iconWrapperClassName}
        isStarred={isStarred}
        onStar={onStar}
      />
    </Suspense>
  )
}

interface Props {
  className?: string
  iconWrapperClassName?: string
  id: number
}
function AgentPoolFavoriteStarContainer(props: Props) {
  const {id} = props
  const isStarred = useIsAgentPoolFavorite(id)

  const isLimitReached = useIsAgentPoolFavoriteLimitReached()
  const disabled = !isStarred && isLimitReached
  const toggle = useToggleAgentPoolFavorite()

  const onStar = useCallback(
    (event: React.MouseEvent<any> | null | undefined) => {
      event?.preventDefault()
      event?.stopPropagation()

      toggle(id)
    },
    [id, toggle],
  )

  return (
    <AgentPoolFavoriteStarComponent
      {...props}
      isStarred={isStarred}
      disabled={disabled}
      onStar={onStar}
    />
  )
}

export const AgentPoolFavoriteStar = memo(function AgentPoolFavoriteStarContainerComponent(
  props: Props,
) {
  const isEnabled = useIsAgentPoolFavoriteEnabled()

  return isEnabled ? <AgentPoolFavoriteStarContainer {...props} /> : null
})
